import { AppContext } from 'next/app';

import { isServer } from 'src/utils/common';
import { HTTP_METHODS } from 'src/utils/constants/HttpMethodsConstants';
import { PLATFORM_NAME_CONSTANT } from 'src/utils/constants/stringConstants';

import { getCookie, getLocalStorage } from '../../utils/browserStorageHandler';
import { SINGLE_LAUNCH_API } from '../../utils/constants/ApiConstants';
import { USER_TYPE_LAUNCH_API } from '../../utils/constants/cookieConstants';
import { LAUNCH_USER_TYPES } from '../../utils/constants/LaunchApiConstants';
import {
  USER_TOKEN,
  USER_TYPE
} from '../../utils/constants/localStorageConstants';
import { buildUrlWithQueryParams } from '../../utils/UrlGenerator';
import { httpService } from '../fetch/HttpService';
import { SingleLaunchResponse } from '../responseTypes/singleLaunchResponse';

export const userTypeCookieHandler = (appContext: AppContext) => {
  if (getCookie(USER_TYPE_LAUNCH_API)) {
    return getCookie(USER_TYPE_LAUNCH_API);
  }
  // userType GUEST
  if (getLocalStorage(USER_TOKEN) !== undefined) {
    if (!getLocalStorage(USER_TOKEN)) {
      launchApiUserTypeCookieSetter(appContext, LAUNCH_USER_TYPES.GUEST);
      return LAUNCH_USER_TYPES.GUEST;
    }
    // userType REGISTERED
    if (
      getLocalStorage(USER_TOKEN) &&
      getLocalStorage(USER_TYPE) !== 'premium'
    ) {
      launchApiUserTypeCookieSetter(appContext, LAUNCH_USER_TYPES.REGISTERED);
      return LAUNCH_USER_TYPES.REGISTERED;
    }
    // userType SUBSCRIBED
    if (
      getLocalStorage(USER_TOKEN) &&
      getLocalStorage(USER_TYPE) === 'premium'
    ) {
      launchApiUserTypeCookieSetter(appContext, LAUNCH_USER_TYPES.SUBSCRIBED);
      return LAUNCH_USER_TYPES.SUBSCRIBED;
    }
  }
  launchApiUserTypeCookieSetter(appContext, LAUNCH_USER_TYPES.GUEST);
  return LAUNCH_USER_TYPES.GUEST;
};

const launchApiUserTypeCookieSetter = (
  appContext: AppContext,
  userType: string
) => {
  appContext.ctx.res?.setHeader(
    'Set-Cookie',
    `${USER_TYPE_LAUNCH_API}=${userType}; path=/`
  );
};

interface LaunchApiParams {
  stateCode: string | '';
  countryCode: string;
  platformName: string;
  partnerName: string | undefined;
  userTypeLaunchApi: string;
  appContext: AppContext;
}

export const launchApiHelper = async ({
  stateCode,
  countryCode,
  partnerName,
  userTypeLaunchApi,
  appContext
}: LaunchApiParams) => {
  try {
    const userType = isServer()
      ? userTypeCookieHandler(appContext)
      : userTypeLaunchApi;
    const singleApiUrlparams = {
      version: '0', //version 0, as per the v6 launch api url and response
      user_type:
        partnerName === null
          ? userType ?? LAUNCH_USER_TYPES.GUEST
          : LAUNCH_USER_TYPES.REGISTERED,
      ...(partnerName && { partner_name: partnerName }),
      state: countryCode.toLowerCase() === 'in' ? stateCode : '',
      platform_name: PLATFORM_NAME_CONSTANT.PLATFORM_NAME,
      country: countryCode
    };
    const singleLaunchUrl = SINGLE_LAUNCH_API;
    const response = await httpService.fetchApiData({
      url: buildUrlWithQueryParams(
        singleLaunchUrl as string,
        singleApiUrlparams
      ),
      type: HTTP_METHODS.GET
    });

    return response;
  } catch (error) {
    console.error('Error while fetching Single Launch response', error);
  }
};

export const getDisplayLanguageConfig = (
  launchData: SingleLaunchResponse | null
) => {
  return (
    (launchData &&
      launchData.country_config &&
      launchData.country_config.language_config &&
      launchData.country_config.language_config.display) ||
    []
  );
};

export const getContentLanguageConfig = (
  launchData: SingleLaunchResponse | null
) => {
  return (
    (launchData &&
      launchData.country_config &&
      launchData.country_config.language_config &&
      launchData.country_config.language_config.content) ||
    []
  );
};
